import React, { useState, useEffect } from 'react';
//import { useNavigate } from 'react-router-dom';
//import jwtDecode from "jwt-decode";
//import * as bootstrap from 'bootstrap';
import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
import '../node_modules/jquery/dist/jquery.min.js';
import '../node_modules/react-datetime/css/react-datetime.css';

//Datatable Modules
import "../node_modules/datatables.net-dt/js/dataTables.dataTables"
import "../node_modules/datatables.net-dt/css/jquery.dataTables.min.css"
import "../node_modules/datatables.net-buttons-dt/css/buttons.dataTables.min.css"
import "../node_modules/datatables.net-buttons/js/dataTables.buttons.js"
import "../node_modules/datatables.net-buttons/js/buttons.colVis.js"
import "../node_modules/datatables.net-buttons/js/buttons.flash.js"
import "../node_modules/datatables.net-buttons/js/buttons.html5.js"
import "../node_modules/datatables.net-buttons/js/buttons.print.js"
import "../node_modules/datatables.net-dt/css/jquery.dataTables.min.css"

import { ToastContainer } from 'react-toastify';
import '../node_modules/react-toastify/dist/react-toastify';
import { BrowserRouter, Routes, Route,useNavigate} from 'react-router-dom';
import { useSelector, useDispatch } from "react-redux";
import Login from './components/login/Login';
//import { logout } from "./components/login/loginSlice";
import { ForgotPassword } from './components/login/ForgotPassword';
import PasswordOtpForm from './components/login/PasswordOtpForm';
import UpdatePasswordForm from './components/login/UpdatePasswordForm';

import  PrivateRoute  from "./components/private-route/PrivateRoute";

import Protected from './components/private-route/Protected';
import Dashboard from './components/backend/dashboard/Dashboard';
import MasterPage from './components/backend/layout/MasterPage';
import AllUser from './components/backend/user/AllUser';
import CreateUser from './components/backend/user/CreateUser';
import UserModify from './components/backend/user/UserModify';
//import UserProfile from './components/backend/user/UserProfile';
import AllUserRoles from './components/backend/userRole/AllUserRoles';
import CreateUserRole from './components/backend/userRole/CreateUserRole';
import UserRoleModify from './components/backend/userRole/UserRoleModify';
//import UserModify from './components/backend/user/UserModify';
import './App.css';
import data from "./data/data";
//import Todo from "./pages/Todo";
import BootstrapComponent from "./pages/BootstrapComponent";

//import { NavigationBar } from './components/backend/layout/NavigationBar';
//import { Home } from './components/backend/Home';
//import { About } from './components/backend/About';
import { NoMatch } from './components/backend/NoMatch';
//import SidebarNew from './components/backend/layout/SidebarNew';
import { getUserProfile } from "./components/backend/dashboard/userAction";
//import TestURole from './components/backend/userRole/TestURole';
//import TestRoleRead from './components/backend/userRole/TestRoleRead';
//import TestRoleUpdate from './components/backend/userRole/TestRoleUpdate';

//------------Master Router import ----------------------
import CountryList from './components/backend/country/CountryList';
import CreateCountry from './components/backend/country/CreateCountry';
import ModifyCountry from './components/backend/country/ModifyCountry';
import CurrencyList from './components/backend/currency/CurrencyList';
import CreateCurrency from './components/backend/currency/CreateCurrency';
import ModifyCurrency from './components/backend/currency/ModifyCurrency';
import CityList from './components/backend/city/CityList';
import CreateCity from './components/backend/city/CreateCity';
import ModifyCity from './components/backend/city/ModifyCity';
import ServiceTypeList from './components/backend/serviceType/ServiceTypesList';
import CreateServiceType from './components/backend/serviceType/CreateServiceType';
import ModifyServiceType from './components/backend/serviceType/ModifyServiceType';
import RolePermissionList from './components/backend/userRolePermission/rolepermission';


// -------------------------Reservation Emaail --------------------
import ReservationEmailList from './components/backend/reservationemails/ReservationEmailList';
import CreateReservationEmail from './components/backend/reservationemails/CreateReservationEmail';
import ModifyReservationEmail from './components/backend/reservationemails/ModifyReservationEmail';

//-------------------------------------------------------------



// -------------------------Commission --------------------
import ExcursionCommissionList from './components/backend/commission/ExcursionCommissionList';
import TransferCommissionList from './components/backend/commission/TransferCommissionList';
import HolidayCommissionList from './components/backend/commission/HolidayCommissionList';
import CreateExcursionCommission from './components/backend/commission/CreateExcursionCommission';
import ModifyCommission from './components/backend/commission/Modifycommission';
import CommissionView from './components/backend/commission/CommissionView';

//-------------------------------------------------------------


// -------------------------Ticket Type  -----------------------------------------
import TicketTypeList from './components/backend/ticketTypes/TicketTypeList';
import CreateTicketType from './components/backend/ticketTypes/CreateTicketType';
import ModifyTicketType from './components/backend/ticketTypes/ModifyTicketType';

//----------------------------------------------------------------------------------

// -------------------------Tour Type  -----------------------------------------
import TourTypeList from './components/backend/tourTypes/TourTypeList';
import CreateTourType from './components/backend/tourTypes/CreateTourType';
import ModifyTourType from './components/backend/tourTypes/ModifyTourType';

//----------------------------------------------------------------------------------

/*------------------Supplier----------------------------*/
import SuppliersList from './components/backend/suppliers/SupplierList';
import CustomersList from './components/backend/customer/AllCustomers';
import CreateSupplier from './components/backend/suppliers/CreateSupplier';
import ModifySupplier from './components/backend/suppliers/ModifySupplier';
//------------Supplier ----------------------

/*------------------Product----------------------------*/
import ProductList from './components/backend/product/ProductList';
import CreateProduct from './components/backend/product/CreateProduct';
import ModifyProduct from './components/backend/product/ModifyProduct';


/*------------------Product----------------------------*/

/*--------------------------Approval------------------------------*/
import ApprovalCommissionList from './components/backend/approval/approvalCommissionList';
import ViewDetails from './components/backend/approval/ViewDetails';
/*--------------------------Approval------------------------------*/


/*------------------Sub Product----------------------------*/
import SubProductList from './components/backend/subproduct/SubProductList';
import SubProductListId from './components/backend/subproduct/SubProductListId';
import CreateSubProduct from './components/backend/subproduct/CreateSubProduct';
import ModifySubProduct from './components/backend/subproduct/ModifySubProduct';
import RateAddMore from './components/backend/subproduct/RateAddMore';
import ViewRates from './components/backend/subproduct/ViewRates';
import ModifyRates from './components/backend/subproduct/ModifyRates';
import ViewRatesPage from './components/backend/subproduct/ViewRatesPage';
import ViewRatesSingleView from './components/backend/subproduct/RatesSingleView';
import ViewItenaryPage from './components/backend/subproduct/ViewItenaryPage';


/*------------------Sub Product----------------------------*/
/*------------------Stop Sale------------------------------*/
import StopSaleList from './components/backend/stopsale/StopSaleList';
import StopSaleList2 from './components/backend/stopsale/StopSaleList2';
import StopSaleList3 from './components/backend/stopsale/StopSaleList3';
import CreateStopSale from './components/backend/stopsale/CreateStopSale';
import ModifyStopSale from './components/backend/stopsale/ModifyStopSale';
/*---------------------------------------------------------*/

/*----------Testing ------------*/
/* import AllSupplier from './components/backend/supplier/AllSupplier';
import SupplierList from './components/backend/supplier/SupplierList';
import AddSupplier from './components/backend/supplier/AddSupplier'; */
/*----------Testing ------------*/



function App() {
  setTimeout(function () {
    let token = localStorage.getItem('accessIsLogIn');
    //console.log('access token '+ token);
  }, 50);

  const dispatch = useDispatch();
  //const navigate = useNavigate();

  
  const [isOpened, setIsOpened] = useState(false);
  const accessIsLogIn1 = localStorage.getItem('accessIsLogIn');  // localstorage value get
  const accessIsLogIn = sessionStorage.getItem('accessIsLogIn');  // localstorage value get
  const { islogIn } = useSelector((state) => state.login); // redux intial object value call
  const accessJWT = sessionStorage.getItem('accessJWT');
  /* console.log('accesslocal '+accessIsLogIn1);
  console.log('accesssession '+accessIsLogIn); */
  console.log('islogIn-app- '+accessIsLogIn);


  const [Data, setData] = useState({

    userFirstName: '',

    userLastName: ''

  });
//console.log('expire '+jwtDecode(accessJWT).exp < Date.now() / 1000);
  
  // console.log('name '+getUserProfile.name);
 
  useEffect(() => {
    
   // console.log('checked outside ' + accessIsLogIn);
    if (accessIsLogIn) {
    //  console.log('checked logged');
      dispatch(getUserProfile());
    }
    /* if (jwtDecode(accessJWT).exp < Date.now() / 1000) {
    
      localStorage.clear();
      sessionStorage.clear();
      dispatch(logout());
     // navigate('/login', { replace: true });
    } */
    
if(accessIsLogIn===null){
  //console.log('checked inside ' + accessIsLogIn);
  //navigate('/login', { replace: true });

  //navigate('/login');
}


  }, [accessIsLogIn]);


  /*useEffect(() => {
    if (!accessIsLogIn1) {
      navigate("/login");
    }
  }, [islogIn,accessIsLogIn,navigate]);*/

  return (
    <div className="wrapper">
      <ToastContainer />
      <BrowserRouter forceRefresh={true} >

<Routes>
{/* <Route  path="/" element={<Login />} /> */}
  {/* <Route path="/login" element={<Login />} /> */}


  <Route path='/login' element={<PrivateRoute accessIsLogIn={accessIsLogIn}><Login /></PrivateRoute>}/>
  <Route path='/' element={<PrivateRoute accessIsLogIn={accessIsLogIn}><Login /></PrivateRoute>}/>
</Routes>
<Routes>
<Route path='/forgot-password' element={<PrivateRoute accessIsLogIn={accessIsLogIn}><ForgotPassword /></PrivateRoute>}/>
<Route path='/password-reset' element={<PrivateRoute accessIsLogIn={accessIsLogIn}><PasswordOtpForm /></PrivateRoute>}/>
<Route path='/update-password' element={<PrivateRoute accessIsLogIn={accessIsLogIn}><UpdatePasswordForm /></PrivateRoute>}/>  
    
    <Route path="*" element={NoMatch} />
</Routes>
{/* {accessIsLogIn && ( */}
 
  {/* {accessIsLogIn && <MasterPage />} */}

    <Routes>
      {data.map((val, index) => (
        <Route path={val.route} key={index} component={<BootstrapComponent data={val} />} />

      ))}
       
 
<Route path='/dashboard' element={<Protected accessIsLogIn={accessIsLogIn}><MasterPage><Dashboard /></MasterPage></Protected>}/>
<Route path='/allUsers'  element={<Protected accessIsLogIn={accessIsLogIn}><MasterPage><AllUser style={{marginLeft:'200px'}} /></MasterPage></Protected>}/>
<Route path='/CreateUser'  element={<Protected accessIsLogIn={accessIsLogIn}><MasterPage><CreateUser /></MasterPage></Protected>}/>     

<Route path='/allRoles'  element={<Protected accessIsLogIn={accessIsLogIn}><MasterPage><AllUserRoles /></MasterPage></Protected>}/>  
    
      
      {/* <Route path='/profile'  element={<Protected accessIsLogIn={accessIsLogIn}><MasterPage><UserProfile/></MasterPage></Protected>}/> */}
      {/* <Route path="/allRoles" replace  element={<AllUserRoles />} /> */}
      <Route path='/modifyUser/:id'  element={<Protected accessIsLogIn={accessIsLogIn}><MasterPage><UserModify /></MasterPage></Protected>}/>
      <Route path='/modifyUser/:profile/:id'  element={<Protected accessIsLogIn={accessIsLogIn}><MasterPage><UserModify /></MasterPage></Protected>}/>
      <Route path='/CreateUserRole'  element={<Protected accessIsLogIn={accessIsLogIn}><MasterPage><CreateUserRole /></MasterPage></Protected>}/>
      <Route path='/userRoleModify/:id'  element={<Protected accessIsLogIn={accessIsLogIn}><MasterPage><UserRoleModify/></MasterPage></Protected>}/>
   
      <Route path="/countryList"  element={<Protected accessIsLogIn={accessIsLogIn}><MasterPage><CountryList/></MasterPage></Protected>}/>
      <Route path="/CreateCountry"  element={<Protected accessIsLogIn={accessIsLogIn}><MasterPage><CreateCountry/></MasterPage></Protected>}/>
      <Route path="/modifyCountry/:id"  element={<Protected accessIsLogIn={accessIsLogIn}><MasterPage><ModifyCountry/></MasterPage></Protected>}/>

      <Route path="/currencyList"  element={<Protected accessIsLogIn={accessIsLogIn}><MasterPage><CurrencyList/></MasterPage></Protected>}/>
      {/* <Route path="/currencyList" replace  element={<CurrencyList/>} /> */}
      <Route path="/createCurrency"  element={<Protected accessIsLogIn={accessIsLogIn}><MasterPage><CreateCurrency/></MasterPage></Protected>}/>
      <Route path="/modifyCurrency/:id"  element={<Protected accessIsLogIn={accessIsLogIn}><MasterPage><ModifyCurrency/></MasterPage></Protected>}/>

      <Route path="/cityList"  element={<Protected accessIsLogIn={accessIsLogIn}><MasterPage><CityList/></MasterPage></Protected>}/>
      {/* <Route path="/cityList" replace  element={<CityList/>} /> */}
      <Route path="/createCity"  element={<Protected accessIsLogIn={accessIsLogIn}><MasterPage><CreateCity/></MasterPage></Protected>}/>
      <Route path="/modifyCity/:id"  element={<Protected accessIsLogIn={accessIsLogIn}><MasterPage><ModifyCity/></MasterPage></Protected>}/>

      <Route path="/serviceTypeList"  element={<Protected accessIsLogIn={accessIsLogIn}><MasterPage><ServiceTypeList/></MasterPage></Protected>}/>
      {/* <Route path="/serviceTypeList" replace  element={<ServiceTypeList/>} /> */}
      <Route path="/createServiceType"  element={<Protected accessIsLogIn={accessIsLogIn}><MasterPage><CreateServiceType/></MasterPage></Protected>}/>
      <Route path="/modifyServiceType/:id"  element={<Protected accessIsLogIn={accessIsLogIn}><MasterPage><ModifyServiceType/></MasterPage></Protected>}/>
      

      <Route path="/reservationEmailList"  element={<Protected accessIsLogIn={accessIsLogIn}><MasterPage><ReservationEmailList/></MasterPage></Protected>}/>
      <Route path="/excursionCommissionList/:name"  element={<Protected accessIsLogIn={accessIsLogIn}><MasterPage><ExcursionCommissionList/></MasterPage></Protected>}/>
      <Route path="/approvalCommissionList"  element={<Protected accessIsLogIn={accessIsLogIn}><MasterPage><ApprovalCommissionList/></MasterPage></Protected>}/>
      <Route path="/transferCommissionList/:name"  element={<Protected accessIsLogIn={accessIsLogIn}><MasterPage><TransferCommissionList/></MasterPage></Protected>}/>
      <Route path="/holidayCommissionList/:name"  element={<Protected accessIsLogIn={accessIsLogIn}><MasterPage><HolidayCommissionList/></MasterPage></Protected>}/>
      <Route path="/ticketypesList"  element={<Protected accessIsLogIn={accessIsLogIn}><MasterPage><TicketTypeList/></MasterPage></Protected>}/>
      <Route path="/tourtypesList"  element={<Protected accessIsLogIn={accessIsLogIn}><MasterPage><TourTypeList/></MasterPage></Protected>}/>
      {/* <Route path="/serviceTypeList" replace  element={<ServiceTypeList/>} /> */}
      <Route path="/createReservationEmail"  element={<Protected accessIsLogIn={accessIsLogIn}><MasterPage><CreateReservationEmail/></MasterPage></Protected>}/>
      <Route path="/createExcursionCommission/:name"  element={<Protected accessIsLogIn={accessIsLogIn}><MasterPage><CreateExcursionCommission/></MasterPage></Protected>}/>
      <Route path="/modifyCommission/:idd/:name1/:name2"  element={<Protected accessIsLogIn={accessIsLogIn}><MasterPage><ModifyCommission/></MasterPage></Protected>}/>
      <Route path="/CommissionView/:idd/:name1/:name2" element={<Protected accessIsLogIn={accessIsLogIn}><MasterPage><CommissionView/></MasterPage></Protected>}/>
      <Route path="/ViewDetails/:idd"  element={<Protected accessIsLogIn={accessIsLogIn}><MasterPage><ViewDetails/></MasterPage></Protected>}/>
      <Route path="/createTicketType"  element={<Protected accessIsLogIn={accessIsLogIn}><MasterPage><CreateTicketType/></MasterPage></Protected>}/>
      <Route path="/createTourType"  element={<Protected accessIsLogIn={accessIsLogIn}><MasterPage><CreateTourType/></MasterPage></Protected>}/>
      <Route path="/modifyReservationEmail/:id"  element={<Protected accessIsLogIn={accessIsLogIn}><MasterPage><ModifyReservationEmail/></MasterPage></Protected>}/>
      <Route path="/modifyTicketType/:id"  element={<Protected accessIsLogIn={accessIsLogIn}><MasterPage><ModifyTicketType/></MasterPage></Protected>}/>
      <Route path="/modifyTourType/:id"  element={<Protected accessIsLogIn={accessIsLogIn}><MasterPage><ModifyTourType/></MasterPage></Protected>}/>





      <Route path="/supplierLists"  element={<Protected accessIsLogIn={accessIsLogIn}><MasterPage><SuppliersList /></MasterPage></Protected>}/>   
      <Route path="/allCustomers"  element={<Protected accessIsLogIn={accessIsLogIn}><MasterPage><CustomersList /></MasterPage></Protected>}/>   
      {/* <Route path="/allSuppliers" replace  element={<SuppliersList/>} /> */}
      <Route path="/createSupplier"  element={<Protected accessIsLogIn={accessIsLogIn}><MasterPage><CreateSupplier/></MasterPage></Protected>}/> 
      <Route path="/modifySupplier/:id"  element={<Protected accessIsLogIn={accessIsLogIn}><MasterPage><ModifySupplier/></MasterPage></Protected>}/> 

      {/* <Route path="/productList" replace  element={<ProductList/>} /> */}
      <Route path="/modifyProduct/:id"  element={<Protected accessIsLogIn={accessIsLogIn}><MasterPage><ModifyProduct/></MasterPage></Protected>}/> 
      <Route path="/modifySubProduct/:id"  element={<Protected accessIsLogIn={accessIsLogIn}><MasterPage><ModifySubProduct/></MasterPage></Protected>}/> 
      <Route path="/modifySubProduct/:id/:pid/:pname"  element={<Protected accessIsLogIn={accessIsLogIn}><MasterPage><ModifySubProduct/></MasterPage></Protected>}/> 
      <Route path="/modifyStopSale/:id/:id2/:mainid/:name1/:name2"  element={<Protected accessIsLogIn={accessIsLogIn}><MasterPage><ModifyStopSale/></MasterPage></Protected>}/> 
      <Route path="/rateaddmore/:SubProductId/:name/:pid/:pname"  element={<Protected accessIsLogIn={accessIsLogIn}><MasterPage><RateAddMore/></MasterPage></Protected>}/> 
      <Route path="/viewrates/:baseId/:pid1/:pname1/:pid2/:pname2"  element={<Protected accessIsLogIn={accessIsLogIn}><MasterPage><ViewRates/></MasterPage></Protected>}/> 
      <Route path="/viewrates/:baseId/:pid1/:pname1/:pid2/:pname2/:name2"  element={<Protected accessIsLogIn={accessIsLogIn}><MasterPage><ViewRates/></MasterPage></Protected>}/> 
      <Route path="/modifyrates/:baseId/:pid1/:pname1/:pid2/:pname2"  element={<Protected accessIsLogIn={accessIsLogIn}><MasterPage><ModifyRates/></MasterPage></Protected>}/> 
      <Route path="/viewratespage/:SubProductId/:name/:pid/:pname"  element={<Protected accessIsLogIn={accessIsLogIn}><MasterPage><ViewRatesPage/></MasterPage></Protected>}/> 
      <Route path="/viewratessingleview/:SubProductId/:name/:pid/:pname"  element={<Protected accessIsLogIn={accessIsLogIn}><MasterPage><ViewRatesSingleView/></MasterPage></Protected>}/> 
      <Route path="/viewitenarypage/:SubProductId/:name/:pid/:pname"  element={<Protected accessIsLogIn={accessIsLogIn}><MasterPage><ViewItenaryPage/></MasterPage></Protected>}/> 
      <Route path="/viewratespage/:SubProductId/:name/:pid/:pname/:name2"  element={<Protected accessIsLogIn={accessIsLogIn}><MasterPage><ViewRatesPage/></MasterPage></Protected>}/> 
      <Route path="/productList"  element={<Protected accessIsLogIn={accessIsLogIn}><MasterPage><ProductList/></MasterPage></Protected>}/> 
      <Route path="/subproductList"  element={<Protected accessIsLogIn={accessIsLogIn}><MasterPage><SubProductList/></MasterPage></Protected>}/> 
      <Route path="/stopsaleList"  element={<Protected accessIsLogIn={accessIsLogIn}><MasterPage><StopSaleList/></MasterPage></Protected>}/> 
      <Route path="/stopsaleList2/:id/:name"  element={<Protected accessIsLogIn={accessIsLogIn}><MasterPage><StopSaleList2/></MasterPage></Protected>}/> 
      <Route path="/stopsaleList3/:mainid/:id/:name/:name2"  element={<Protected accessIsLogIn={accessIsLogIn}><MasterPage><StopSaleList3/></MasterPage></Protected>}/> 
      <Route path="/subproductList/:name"  element={<Protected accessIsLogIn={accessIsLogIn}><MasterPage><SubProductList/></MasterPage></Protected>}/> 
      <Route path="/subproductListId/:id/:name"  element={<Protected accessIsLogIn={accessIsLogIn}><MasterPage><SubProductListId/></MasterPage></Protected>}/> 
      <Route path="/subproductListId/:id/:name/:name2"  element={<Protected accessIsLogIn={accessIsLogIn}><MasterPage><SubProductListId/></MasterPage></Protected>}/> 
      <Route path="/createProduct"  element={<Protected accessIsLogIn={accessIsLogIn}><MasterPage><CreateProduct/></MasterPage></Protected>}/>
      <Route path="/createStopSale"  element={<Protected accessIsLogIn={accessIsLogIn}><MasterPage><CreateStopSale/></MasterPage></Protected>}/>
      <Route path="/createSubProduct"  element={<Protected accessIsLogIn={accessIsLogIn}><MasterPage><CreateSubProduct/></MasterPage></Protected>}/>
	  
	   <Route path="/rolepermission/:id"  element={<Protected accessIsLogIn={accessIsLogIn}><MasterPage><RolePermissionList/></MasterPage></Protected>}/>

      <Route path="*" element={NoMatch} />
     
    </Routes>
  
{/* )} */}

</BrowserRouter>
     
    
    </div>

  )
}
export default App